<template>
    <b-card class="white-card shadow-sm" :title="planTitle">
        <div :class="{ busy: loading }">
            <div v-if="loading" class="text-center">
                <b-spinner variant="primary" class="my-2" />
            </div>
            <div v-if="!loading && subscription">
                <b-card-text>
                    <h4 v-show="store" class="store-text m-0">
                        Store: <span class="primary-text">{{ store }}</span>
                    </h4>
                </b-card-text>
            </div>
        </div>
    </b-card>
</template>

<script lang="ts" setup>
import { Subscription, SubscriptionStatus } from '@/api/typings/billing';
import { getPlanDescription } from '@/utils/billing';
import { computed } from 'vue';

const props = defineProps<{
    subscription: Subscription;
    store: string;
    loading?: boolean;
}>();

const planTitle = computed(() => {
    if (props.loading) return '';

    const inactiveStatuses: SubscriptionStatus[] = ['canceled', 'unpaid', 'incomplete', 'incomplete_expired'];

    if (!props.subscription || inactiveStatuses.includes(props.subscription.Status)) {
        return 'No active plan';
    }

    if (props.subscription.Plan) {
        const description = getPlanDescription(props.subscription.Plan);
        if (description) {
            return description;
        }
    }
    return 'Unknown Plan';
});
</script>

<style lang="scss" scoped>
.store-text {
    font-size: 18px;
}
</style>
